import { StripedTableRow as StyledTableRow } from '@edge/spark/ui-mui'
import { Paper, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { StyledTable } from './VehicleHelpTab'

const rows = [
    { name: 'Buyer Name', prefix: 'buyer:', example: 'buyer:herron' },
    { name: 'Seller Name', prefix: 'seller:', example: 'seller:warren' },
    { name: 'Buyer ID', prefix: 'buyerid:', example: 'buyerid:A00950' },
    { name: 'Seller ID', prefix: 'sellerid:', example: 'sellerid:A00403' },
    { name: 'State', prefix: 'state:', example: 'state:WA' },
    { name: 'Zip Code', prefix: 'zip:', example: 'zip:12345' },
]

const CompanyHelpTab = () => {
    return (
        <Paper sx={{ width: '100%', mt: 2, overflowX: 'auto', minHeight: 428 }}>
            <StyledTable aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left">Search</TableCell>
                        <TableCell align="center">Prefix</TableCell>
                        <TableCell align="center">Example</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <StyledTableRow key={row.name}>
                            <TableCell align="left">{row.name}</TableCell>
                            <TableCell align="center">{row.prefix}</TableCell>
                            <TableCell align="center">{row.example}</TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </StyledTable>
        </Paper>
    )
}

export default CompanyHelpTab
